module.exports = __webpack_public_path__ + "img/20191114.b7e72148.png";